import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.251 40.251"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Group 5093\"><g data-name=\"Ellipse 1504\" style=\"stroke:#989898;fill:none;\"><circle cx=\"20.125\" cy=\"20.125\" r=\"20.125\" style=\"stroke:none;\" stroke=\"none\"></circle><circle cx=\"20.125\" cy=\"20.125\" r=\"19.625\" style=\"fill:none;\"></circle></g><path data-name=\"Path 8423\" d=\"m3 9.785.976.976 6.619-6.619v16.69h1.381V4.143l6.619 6.619.976-.976L11.285 1.5z\" transform=\"translate(8.84 8.958)\" style=\"fill:#989898;\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };